import { Progress as MantineProgress, ProgressProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedProgressProps extends ProgressProps {
  gradientVariant?: GradientVariant;
  showValue?: boolean;
}

const Progress = forwardRef<HTMLDivElement, ThemedProgressProps>(
  ({ gradientVariant = 'primary', value, showValue = false, style, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];

    return (
      <MantineProgress
        ref={ref}
        value={value}
        style={{
          ...style,
        }}
        styles={{
          section: {
            backgroundImage: `linear-gradient(90deg, ${gradient.from}, ${gradient.to})`,
          },
          label: showValue
            ? {
                color: 'white',
                fontWeight: 600,
              }
            : undefined,
        }}
        {...rest}
      >
        {showValue && `${value}%`}
      </MantineProgress>
    );
  }
);

Progress.displayName = 'Progress';

export default Progress;
